<template>
    <modal ref="modal" class="address-modal" :dialog-class="'modal-lg'" body-class="pt-5">
        <div v-if="prompt">
            <h4 class="text-center text-white mb-3">Hi {{$store.getters['auth/firstName']}},<br>
                Let’s get started! It only takes 2 minutes to set up...</h4>
            <br>
        </div>
        <address-locator @selected="onAddressSelected" />
    </modal>
</template>

<script>
import Modal from "../Modal";
import AddressLocator from "../AddressLocator";

export default {
        name: "AddressModal",
        components: {AddressLocator, Modal},
        props: {
            prompt: Boolean,
        },
        methods: {
            show: function () {
                this.$refs.modal.show();
            },
            hide: function () {
                this.$refs.modal.hide();
            },
            onAddressSelected: function (address) {
                this.$emit('selected', address)
                this.hide();
            }
        }
    }
</script>

<style scoped lang="scss">
@import "../../sass/base";
.address-modal {
    ::v-deep {
        .modal-dialog {
            @include media-breakpoint-down(lg){
                top: 30%;
            }
        }
    }
    
}
    ::v-deep {
        
        .modal-content {
            background: transparent url("../../assets/images/leadin.png") center center no-repeat;
            background-size: cover;
        }
        .modal-body {
            padding: 1rem 1rem 3rem;
            @include media-breakpoint-up(lg){
                padding: 5rem 2rem 7rem;
            }
        }
    }
</style>
